import format from "date-fns/format";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";

import DatesPicker from "~/shared/ui/Fields/PdDatePicker";

import s from "./../BonusQReport.less";

interface QReportFilterIProps {
  changeDate: (date: string) => void;
}

const QReportFilter: React.FC<QReportFilterIProps> = ({ changeDate }) => {
  const { control, watch } = useForm({ defaultValues: { year: new Date() } });

  useEffect(() => {
    const year = watch("year");
    if (year) {
      changeDate(format(new Date(year), "yyyy"));
    }
  }, [watch("year")]);

  return (
    <div className={s.filter}>
      <span className={s.filterTitle}>Год</span>
      <DatesPicker
        name={"year"}
        control={control}
        showYearPicker={true}
        dateFormat="yyyy"
        customClassName={s.custom_datePicker}
        placeholder="Выберите год"
      />
    </div>
  );
};

export default QReportFilter;
